import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import axios from 'axios';
import Actions from './actions';
import { errorDuck } from '../error';
import { drop } from "lodash";
import moment from "moment";
import * as UTIL from '../../util';
import { toPascal } from '../../util';
import { CATALOGUETYPES } from "../../constants";
import { newCartInfoGA as newCartInfo, purchaseConfirmation } from "../../util/ga-analytics";
import { gaDefault, gaTracker } from '../../util/ga-analytics/gaTracker';
import { billingSchemes, setloyaltydataResponse } from './mockResponses';
import { rewardsDuck } from '../rewards';
import { getSessionStorageKey } from '../../util/sessionStorage';
import { giftCardBalanceResponse } from './mockResponses';
import { removeTipAndEntitlementsOptions } from '../../util/constants';
import calculateProductPriceWithoutQuantity from '../../util/ga-analytics/gaCartPriceCalc';
import { pageCategoryNames } from '../../util/ga-analytics/util/categoriesParser';

var Filter = require('bad-words');

var filter = new Filter();
var Creators = Actions.Creators;
var requestCart = Creators.request;
var receiveCart = Creators.response;
var postItemCart = Creators.postItem;
var recievePostItemCart = Creators.postItemReceive;
var patchItemCart = Creators.patchItem;
var closeAddTo = Creators.closeAddTo;
var deleteFromCart = Creators.delete;
var requestDeliveryMode = Creators.requestDeliveryMode;
var recieveDeliveryMode = Creators.recieveDeliveryMode;
var requestTimeWanted = Creators.requestTimeWanted;
var recieveTimeWanted = Creators.recieveTimeWanted;
var requestDeliveryInfo = Creators.requestDeliveryInfo;
var requestDeliveryInfoFail = Creators.requestDeliveryInfoFail;
var recieveDeliveryInfo = Creators.recieveDeliveryInfo;
var requestSubmitCart = Creators.requestSubmitCart;
var recieveSubmitCart = Creators.recieveSubmitCart;
var closeCheckout = Creators.closeCheckout;
var hitCheckout = Creators.setGoToCheckout;
var actionSaveForEdit = Creators.saveForEdit;
var resetSaveForEdit = Creators.resetSaveForEdit;
var requestPostTip = Creators.requestPostTip;
var recievePostTip = Creators.recievePostTip;
var requestDeliveryModeOptions = Creators.requestDeliveryModeOptions;
var recieveDeliveryModeOptions = Creators.recieveDeliveryModeOptions;
var requestCurbside = Creators.requestCurbside;
var recieveCurbside = Creators.recieveCurbside;
var requestPromoCode = Creators.requestPromoCode;
var recievePromoCode = Creators.recievePromoCode;
var removePromoCode = Creators.removePromoCode;
var storeDeliveryMode = Creators.setDeliveryMode;
var setShippingMode = Creators.setShippingMode;
var requestValidateCart = Creators.requestValidateCart;
var recieveValidateCart = Creators.recieveValidateCart;
var hideValidateCart = Creators.hideValidateCart;
var requestClearCart = Creators.requestClearCart;
var recieveClearCart = Creators.recieveClearCart;
var requestGiftCard = Creators.requestGiftCard;
var recieveGiftCard = Creators.recieveGiftCard;
var requestGiftCardScheme = Creators.requestGiftCardScheme;
var recieveGiftCardScheme = Creators.recieveGiftCardScheme;
var clearStates = Creators.clearStates;
var requestShippingModes = Creators.requestShippingModes;
var recieveShippingModes = Creators.recieveShippingModes;
var recieveSavedCards = Creators.recieveSavedCards;
var setPaypalOrder = Creators.setPaypalOrder;
var requestPaypalOrder = Creators.requestPaypalOrder;
var resetPaypalOrder = Creators.resetPaypalOrder;
var resetLoading = Creators.resetLoading;
var setIsLoading = Creators.setIsLoading;
var newsLetterRequest = Creators.newsLetterRequest;
var newsLetterResponse = Creators.newsLetterResponse;
var reciveLeadtimeErr = Creators.reciveLeadtimeErr;
var recieveTokenExAuthKey = Creators.tokenExGetAuthKey;
var setPostLoyaltyData = Creators.setPostLoyaltyData;
var redeemRewardsAction = Creators.redeemRewardsAction;
var resetRewardsCartAction = Creators.resetRewardsCartAction;
var errorOperations = errorDuck.operations;
var receiveError = errorOperations.receiveError;
var resetError = errorOperations.resetError;
var rewardOperations = rewardsDuck.operations;
export var newCart = function newCart(state, json) {
  var _json$FoodDelivery, _json$FoodDelivery$Ea, _json$FoodDelivery2, _json$FoodDelivery2$C, _json$OloDiscount, _json$Price, _json$OloDiscount2, _json$Price2, _json$OloDiscount3, _json$OloDiscount4, _state$cart, _state$cart$giftCardI, _state$cart$giftCardI2, _state$cart2, _state$cart2$giftCard, _state$cart$giftCardI3, _json$FoodDelivery3, _json$FoodDelivery4;

  var displayErrors = (json === null || json === void 0 ? void 0 : json.DisplayMessages) || [];
  var foodCharge = (json === null || json === void 0 ? void 0 : (_json$FoodDelivery = json.FoodDelivery) === null || _json$FoodDelivery === void 0 ? void 0 : (_json$FoodDelivery$Ea = _json$FoodDelivery.EatDelivery) === null || _json$FoodDelivery$Ea === void 0 ? void 0 : _json$FoodDelivery$Ea.DeliveryCharge) || 0;
  var caterCharge = (json === null || json === void 0 ? void 0 : (_json$FoodDelivery2 = json.FoodDelivery) === null || _json$FoodDelivery2 === void 0 ? void 0 : (_json$FoodDelivery2$C = _json$FoodDelivery2.CaterDelivery) === null || _json$FoodDelivery2$C === void 0 ? void 0 : _json$FoodDelivery2$C.DeliveryCharge) || 0;
  var deliveryCharge = foodCharge + caterCharge;
  var foodItems = [];
  var caterItems = [];
  var retailItems = [];
  var cart = Array.isArray(json.CartLines) ? json.CartLines : [];
  cart.forEach(function (item) {
    var _item$Product;

    var catalogName = item === null || item === void 0 ? void 0 : (_item$Product = item.Product) === null || _item$Product === void 0 ? void 0 : _item$Product.CatalogName;

    switch (catalogName) {
      case CATALOGUETYPES.cater:
        caterItems.push(item);
        break;

      case CATALOGUETYPES.food:
        foodItems.push(item);
        break;

      case CATALOGUETYPES.retail:
        retailItems.push(item);
        break;
    }
  });
  var a = {
    cart: cart,
    displayErrors: displayErrors,
    destructuredCart: {
      foodItems: foodItems,
      caterItems: caterItems,
      retailItems: retailItems
    },
    price: _objectSpread(_objectSpread({}, json.Price), {}, {
      DeliveryCharge: isNaN(deliveryCharge) ? 0 : deliveryCharge,
      TotalSavings: isNaN(json === null || json === void 0 ? void 0 : (_json$OloDiscount = json.OloDiscount) === null || _json$OloDiscount === void 0 ? void 0 : _json$OloDiscount.Discount) ? json === null || json === void 0 ? void 0 : (_json$Price = json.Price) === null || _json$Price === void 0 ? void 0 : _json$Price.TotalSavings : (json === null || json === void 0 ? void 0 : (_json$OloDiscount2 = json.OloDiscount) === null || _json$OloDiscount2 === void 0 ? void 0 : _json$OloDiscount2.Discount) + (json === null || json === void 0 ? void 0 : (_json$Price2 = json.Price) === null || _json$Price2 === void 0 ? void 0 : _json$Price2.TotalSavings),
      CateringDiscount: (json === null || json === void 0 ? void 0 : (_json$OloDiscount3 = json.OloDiscount) === null || _json$OloDiscount3 === void 0 ? void 0 : _json$OloDiscount3.CateringDiscount) != 0 ? json === null || json === void 0 ? void 0 : (_json$OloDiscount4 = json.OloDiscount) === null || _json$OloDiscount4 === void 0 ? void 0 : _json$OloDiscount4.CateringDiscount : 0,
      Remaining: ((_state$cart = state.cart) === null || _state$cart === void 0 ? void 0 : (_state$cart$giftCardI = _state$cart.giftCardInfo) === null || _state$cart$giftCardI === void 0 ? void 0 : _state$cart$giftCardI.balance) ? Math.max(0, json.Price.Total - ((_state$cart$giftCardI2 = state.cart.giftCardInfo) === null || _state$cart$giftCardI2 === void 0 ? void 0 : _state$cart$giftCardI2.balance)) : undefined,
      Used: ((_state$cart2 = state.cart) === null || _state$cart2 === void 0 ? void 0 : (_state$cart2$giftCard = _state$cart2.giftCardInfo) === null || _state$cart2$giftCard === void 0 ? void 0 : _state$cart2$giftCard.balance) ? Math.min(json.Price.Total, (_state$cart$giftCardI3 = state.cart.giftCardInfo) === null || _state$cart$giftCardI3 === void 0 ? void 0 : _state$cart$giftCardI3.balance) : undefined
    }),
    cater: (_json$FoodDelivery3 = json.FoodDelivery) === null || _json$FoodDelivery3 === void 0 ? void 0 : _json$FoodDelivery3.CaterDelivery,
    food: (_json$FoodDelivery4 = json.FoodDelivery) === null || _json$FoodDelivery4 === void 0 ? void 0 : _json$FoodDelivery4.EatDelivery,
    isCatering: Boolean(caterItems.length),
    isCater: Boolean(caterItems.length),
    isFood: Boolean(foodItems.length),
    isRetail: Boolean(retailItems.length),
    isTokenExEnabled: json === null || json === void 0 ? void 0 : json.IsTokenExEnabled,
    GiftCardDetails: json === null || json === void 0 ? void 0 : json.GiftCardDetails
  };
  newCartInfo(a);
  return a;
};

var constructError = function constructError(err) {
  var code = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "cb7508";

  try {
    return {
      response: {
        data: {
          results: {
            code: code,
            message: err.Errors[0]
          }
        }
      }
    };
  } catch (_unused) {
    return {
      response: {
        data: {
          results: {
            code: code,
            message: undefined
          }
        }
      }
    };
  }
};

function fetchCart(state, jwtIdToken) {
  return function (dispatch) {
    var _state$account, _state$account$aadRes;

    dispatch(requestCart());
    var storeId = UTIL.getStoreId(state);
    var routeURL = "".concat(UTIL.apiUtil.API.getCart);
    var data = {
      "storeId": storeId
    };
    var token = ((_state$account = state.account) === null || _state$account === void 0 ? void 0 : (_state$account$aadRes = _state$account.aadResponse) === null || _state$account$aadRes === void 0 ? void 0 : _state$account$aadRes.jwtIdToken) || jwtIdToken;
    return UTIL.apiUtil.fetchPost(routeURL, data, token).then(function (json) {
      var newCartObj = newCart(state, json);
      dispatch(receiveCart(newCartObj));

      if (json.Id.includes("00000000-0000-0000-0000-000000000000")) {
        // alert("Error: You have a shared cart ")
        dispatch(receiveError(UTIL.buildError(constructError({
          Errors: ["Shared Cart Found"]
        }, "cb7508"))));
      }
    }).catch(function (err) {
      console.error('fetchCart error', err);
      dispatch(receiveError(UTIL.buildError(constructError(err))));
    });
  };
}

function postItemSend(state, postData) {
  return function (dispatch) {
    var _state$cart3, _state$account2, _state$account2$aadRe;

    if (state === null || state === void 0 ? void 0 : (_state$cart3 = state.cart) === null || _state$cart3 === void 0 ? void 0 : _state$cart3.isLoading) return;
    dispatch(postItemCart());
    var storeId = UTIL.getStoreId(state);
    var storeType = UTIL.getPageType(state);

    if (!postData.catalogName) {
      postData.catalogName = storeType; // postData.catalogName = "food"
    }

    if (postData.catalogName !== "shop") {
      postData.storeId = storeId; // postData.storeId = "max-pos-lab-130";
    }

    var routeURL = "".concat(UTIL.apiUtil.API.postCart);
    var data = postData;

    if (postData.specialInstruction && postData.specialInstruction !== '') {
      data = _objectSpread(_objectSpread({}, postData), {}, {
        "specialInstruction": filter.clean(postData.specialInstruction)
      });
    }

    var token = (_state$account2 = state.account) === null || _state$account2 === void 0 ? void 0 : (_state$account2$aadRe = _state$account2.aadResponse) === null || _state$account2$aadRe === void 0 ? void 0 : _state$account2$aadRe.jwtIdToken;
    var mobilePrefix = UTIL.mobileAppUtil.isMobileApp() ? UTIL.apiUtil.API.baseUrl : ''; //absolute url for mobile

    return UTIL.apiUtil.fetchPost(routeURL, data, token).then(function (json) {
      var _json$Data;

      var jsonUpsell = json.Data.UpsellCrossSellCategories || [];
      var upsellInfo = {
        "items": {
          "heading": "Add some Extras?",
          "cardDisplayType": "list",
          "totalCardsInRow": "3",
          "background": "default",
          "padding": null,
          "link": null,
          "categories": jsonUpsell.map(function (el) {
            return {
              "categoryContentPageName": null,
              "categoryContentPagePath": el.DetailLink,
              "slug": el.CategoryName,
              "displayName": el.CategoryName,
              "description": el.CategoryName,
              "image": {
                "src": mobilePrefix + el.ImageUrl,
                "alt": el.CategoryName
              }
            };
          })
        }
      };
      dispatch(recievePostItemCart({
        newItem: data,
        foodBasketId: (_json$Data = json.Data) === null || _json$Data === void 0 ? void 0 : _json$Data.OloFoodStoreBasketId,
        cateringBasketId: json.Data.OloCateringStoreBasketId,
        upsellInfo: upsellInfo
      }));
      dispatch(receiveCart(newCart(state, json.Data)));
    }).catch(function (error) {
      var message = UTIL.buildInternalError('cb7504');

      if (Array.isArray(error.Errors) && error.Errors && error.Errors.length) {
        message.response.data.results.message = error.Errors[0];
      }

      gaDefault(89);
      gaDefault(90);
      dispatch(setIsLoading({
        isLoading: false
      }));
      return dispatch(receiveError(UTIL.buildError(message)));
    });
  };
}

var updateCartLine = function updateCartLine(state, lineId, options, newQuantity, newItemBody, isDetail, addOn) {
  var _state$cart4, _state$cart4$cart, _state$cart4$cart$fin;

  var currentItem = (_state$cart4 = state.cart) === null || _state$cart4 === void 0 ? void 0 : (_state$cart4$cart = _state$cart4.cart) === null || _state$cart4$cart === void 0 ? void 0 : (_state$cart4$cart$fin = _state$cart4$cart.find) === null || _state$cart4$cart$fin === void 0 ? void 0 : _state$cart4$cart$fin.call(_state$cart4$cart, function (x) {
    return x.Id === lineId;
  });
  return function (dispatch) {
    var _state$account3, _state$account3$aadRe;

    dispatch(patchItemCart());
    var routeURL = UTIL.apiUtil.API.updateCart;
    var data = {
      "cartLineId": lineId,
      "quantity": newQuantity,
      "options": options,
      "specialInstruction": newItemBody.specialInstruction ? filter.clean(newItemBody.specialInstruction) : ""
    };

    if (addOn === undefined) {
      if (currentItem === null || currentItem === void 0 ? void 0 : currentItem.AddOnProductDetails) {
        var _currentItem$AddOnPro, _currentItem$AddOnPro2;

        data.AddonProductRequest = {
          StoreProductId: (_currentItem$AddOnPro = currentItem.AddOnProductDetails) === null || _currentItem$AddOnPro === void 0 ? void 0 : _currentItem$AddOnPro.StoreProductId,
          ProductChainId: (_currentItem$AddOnPro2 = currentItem.AddOnProductDetails) === null || _currentItem$AddOnPro2 === void 0 ? void 0 : _currentItem$AddOnPro2.ProductId
        };
      }
    } else {
      if (addOn) {
        data.AddonProductRequest = {
          StoreProductId: addOn.StoreProductId,
          ProductChainId: addOn.ProductChainId
        };
      }
    }

    var token = (_state$account3 = state.account) === null || _state$account3 === void 0 ? void 0 : (_state$account3$aadRe = _state$account3.aadResponse) === null || _state$account3$aadRe === void 0 ? void 0 : _state$account3$aadRe.jwtIdToken;
    return UTIL.apiUtil.fetchPatch(routeURL, data, token).then(function (json) {
      if (isDetail) {
        dispatch(recievePostItemCart({
          newItem: newItemBody,
          foodBasketId: json.Data.OloFoodStoreBasketId,
          cateringBasketId: json.Data.OloCateringStoreBasketId,
          upsellInfo: state.cart.upsellInfo || {}
        }));
      }

      dispatch(receiveCart(newCart(state, json.Data)));
    }).catch(function (err) {
      dispatch(setIsLoading({
        isLoading: false
      }));
      dispatch(rewardOperations.processingRewards(false));
      dispatch(receiveError(UTIL.buildError(constructError(err, "cb7505"))));
    });
  };
};

function getShippingModes() {
  return function (dispatch) {
    dispatch(requestShippingModes());
    var routeURL = "".concat(UTIL.apiUtil.API.cart.getShippingMethods);
    return UTIL.apiUtil.fetchGet(routeURL).then(function (json) {
      dispatch(recieveShippingModes(json));
    }).catch(function (err) {
      console.error(err, "err in Delivery Modes"); // const message = UTIL.buildInternalError('cb7504');
      // return dispatch(receiveError(UTIL.buildError(message)))
    });
  };
}

function deleteCartSend(state, lineId) {
  return function (dispatch) {
    var _state$account4, _state$account4$aadRe;

    dispatch(deleteFromCart());
    var routeURL = UTIL.apiUtil.API.deleteCart;
    var data = {
      "cartLineId": lineId
    };
    var token = (_state$account4 = state.account) === null || _state$account4 === void 0 ? void 0 : (_state$account4$aadRe = _state$account4.aadResponse) === null || _state$account4$aadRe === void 0 ? void 0 : _state$account4$aadRe.jwtIdToken;
    return UTIL.apiUtil.fetchDelete(routeURL, data, token).then(function (json) {
      dispatch(receiveCart(newCart(state, json.Data)));
    }).catch(function (err) {
      dispatch(receiveError(UTIL.buildError(constructError(err, "cb7505"))));
    });
  };
}

var updateTimeWanted = function updateTimeWanted(state, timeObj) {
  return function (dispatch) {
    var _state$account5, _state$account5$aadRe;

    dispatch(requestTimeWanted());
    var routeURL = UTIL.apiUtil.API.setTimeWanted;
    var foodTimeWanted = timeObj.foodTimeWanted,
        caterTimeWanted = timeObj.caterTimeWanted,
        foodDeliveryMode = timeObj.foodDeliveryMode,
        caterDeliveryMode = timeObj.caterDeliveryMode;
    var foodTime;
    var caterTime;

    if (foodTimeWanted) {
      try {
        var formattedTime = typeof foodTimeWanted.time === "number" ? moment.utc(foodTimeWanted.time * 1000).format('HH:mm') : foodTimeWanted.time;
        foodTime = moment("".concat(foodTimeWanted.date, " ").concat(formattedTime));
      } catch (e) {
        return dispatch(receiveError(UTIL.buildError(e)));
      }
    }

    if (caterTimeWanted) {
      try {
        var _formattedTime = typeof caterTimeWanted.time === "number" ? moment.utc(caterTimeWanted.time * 1000).format('HH:mm') : caterTimeWanted.time;

        caterTime = moment("".concat(caterTimeWanted.date, " ").concat(_formattedTime));
      } catch (e) {
        return dispatch(receiveError(UTIL.buildError(e)));
      }
    }

    var data = {
      "foodTimeWanted": foodTime ? {
        "Year": foodTime.year(),
        "Month": foodTime.month() + 1,
        "Day": foodTime.date(),
        "Hour": foodTime.hour(),
        "Minute": foodTime.minute(),
        "IsManualFire": false
      } : null,
      "caterTimeWanted": caterTime ? {
        "Year": caterTime.year(),
        "Month": caterTime.month() + 1,
        "Day": caterTime.date(),
        "Hour": caterTime.hour(),
        "Minute": caterTime.minute(),
        "IsManualFire": false
      } : null
    };
    if (data.caterTimeWanted === null && data.foodTimeWanted === null) return dispatch(receiveError(UTIL.buildError(constructError('Invalid Time Selected', "cb9999"))));
    var token = (_state$account5 = state.account) === null || _state$account5 === void 0 ? void 0 : (_state$account5$aadRe = _state$account5.aadResponse) === null || _state$account5$aadRe === void 0 ? void 0 : _state$account5$aadRe.jwtIdToken;
    return UTIL.apiUtil.fetchPost(routeURL, data, token).then(function () {
      var gtmdata = {
        gtm: {
          uniqueEventId: '109',
          foodTimeWanted: data.foodTimeWanted,
          caterTimeWanted: data.caterTimeWanted,
          elementId: "post-time-wanted"
        },
        event: 'gtm.post'
      };
      gaTracker(gtmdata);
      dispatch(recieveTimeWanted({
        timeWanted: timeObj
      }));
    }).then(function () {}).catch(function (err) {
      var errorInfo = err.Errors;
      var includes = false;
      var isDeliver = foodDeliveryMode === "dispatch" || foodDeliveryMode === "delivery" || caterDeliveryMode === "dispatch" || caterDeliveryMode === "delivery";
      console.error(isDeliver, foodDeliveryMode, caterDeliveryMode, "mode info");

      try {
        includes = errorInfo.includes("Please visit or call to place your order or use the location finder to try another location nearby") || errorInfo.includes("Please schedule your order for another time or select another order type");
      } catch (e) {
        console.error(e, "error in erroInfo");
      }

      if (includes && isDeliver) {
        dispatch(resetLoading());
        return dispatch(receiveError(UTIL.buildError({
          response: {
            data: {
              results: {
                code: "cb7506"
              }
            }
          }
        })));
      }

      dispatch(resetLoading());
      return dispatch(reciveLeadtimeErr(errorInfo));
    });
  };
};

var updateDeliveryInfo = function updateDeliveryInfo(state, deliveryState, street1, street2, city, zip, phone, special, deliveryMode) {
  return function (dispatch) {
    var _state$account6, _state$account6$aadRe;

    dispatch(requestDeliveryInfo());
    var routeURL = UTIL.apiUtil.API.setDeliveryAddress;
    var foodMethod = deliveryMode.foodDeliveryMode;
    var caterMethod = deliveryMode.caterDeliveryMode;
    var data = {
      "FoodDeliveryAddress": foodMethod === "dispatch" || foodMethod === "delivery" ? {
        "Building": "".concat(Boolean(street2) ? "".concat(street2) : ""),
        "StreetAddress": street1,
        "State": deliveryState,
        "City": city,
        "Zipcode": zip,
        "PhoneNumber": phone,
        "SpecialInstructions": special,
        "DeliveryMode": foodMethod
      } : "",
      "CaterDeliveryAddress": caterMethod === "dispatch" || caterMethod === "delivery" ? {
        "Building": "".concat(Boolean(street2) ? "".concat(street2) : ""),
        "StreetAddress": street1,
        "State": deliveryState,
        "City": city,
        "Zipcode": zip,
        "PhoneNumber": phone,
        "SpecialInstructions": special,
        "DeliveryMode": caterMethod
      } : ""
    };
    var token = (_state$account6 = state.account) === null || _state$account6 === void 0 ? void 0 : (_state$account6$aadRe = _state$account6.aadResponse) === null || _state$account6$aadRe === void 0 ? void 0 : _state$account6$aadRe.jwtIdToken;
    return UTIL.apiUtil.fetchPost(routeURL, data, token).then(function (json) {
      dispatch(receiveCart(newCart(state, json.Data)));
      return dispatch(recieveDeliveryInfo({
        deliveryInfo: _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, street1), street2), city), zip), phone), special)
      }));
    }).catch(function (err) {
      var message = UTIL.buildInternalError('cb7503');
      dispatch(resetLoading());
      dispatch(requestDeliveryInfoFail());
      dispatch(receiveError(UTIL.buildError(message)));
      throw "Error";
    });
  };
};

var postRetailOrder = function postRetailOrder(state, addressInfo, deliveryMode) {
  return function (dispatch) {
    var _state$account7, _state$account7$aadRe;

    dispatch(requestCart());
    var routeURL = UTIL.apiUtil.API.cart.setShippingMethods;
    var selectedMode = state.cart.shippingModes.filter(function (mode) {
      return mode.name.toLowerCase() === deliveryMode;
    });
    var data = {
      "OrderShippingPreferenceType": "1",
      "ShippingMethods": selectedMode,
      "ShippingAddresses": [addressInfo]
    };
    var token = (_state$account7 = state.account) === null || _state$account7 === void 0 ? void 0 : (_state$account7$aadRe = _state$account7.aadResponse) === null || _state$account7$aadRe === void 0 ? void 0 : _state$account7$aadRe.jwtIdToken;
    return UTIL.apiUtil.fetchPost(routeURL, data, token).then(function (json) {
      var pascal = toPascal(json);
      dispatch(receiveCart(newCart(state, pascal.Data)));
    }).catch(function (err) {
      dispatch(receiveError(UTIL.buildError(constructError(err, "cb7505"))));
      throw "Error";
    });
  };
};

var postLoyaltyData = function postLoyaltyData(state) {
  return /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(dispatch) {
      var _state$account8, _state$account8$aadRe, _state$account9, _state$account9$aadRe, _state$account9$aadRe2, _state$account9$aadRe3, _state$account10, _state$account10$aadR, _state$account10$aadR2, _state$account10$aadR3;

      var url, token, redeemedRewards, loyaltyId, loyaltyEmail, data, rewardsData;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              url = UTIL.apiUtil.API.cart.postLoyaltyData;
              token = (_state$account8 = state.account) === null || _state$account8 === void 0 ? void 0 : (_state$account8$aadRe = _state$account8.aadResponse) === null || _state$account8$aadRe === void 0 ? void 0 : _state$account8$aadRe.jwtIdToken;
              redeemedRewards = state.rewards.redeemedRewards; // storybook mock

              if (!(window.location.href.indexOf("localhost:9009") > -1)) {
                _context.next = 5;
                break;
              }

              return _context.abrupt("return", Promise.resolve({
                success: true
              }));

            case 5:
              loyaltyId = state.loyalty.account.ExternalCustomerId;
              loyaltyEmail = ((_state$account9 = state.account) === null || _state$account9 === void 0 ? void 0 : (_state$account9$aadRe = _state$account9.aadResponse) === null || _state$account9$aadRe === void 0 ? void 0 : (_state$account9$aadRe2 = _state$account9$aadRe.account) === null || _state$account9$aadRe2 === void 0 ? void 0 : (_state$account9$aadRe3 = _state$account9$aadRe2.idToken) === null || _state$account9$aadRe3 === void 0 ? void 0 : _state$account9$aadRe3.email) || ((_state$account10 = state.account) === null || _state$account10 === void 0 ? void 0 : (_state$account10$aadR = _state$account10.aadResponse) === null || _state$account10$aadR === void 0 ? void 0 : (_state$account10$aadR2 = _state$account10$aadR.account) === null || _state$account10$aadR2 === void 0 ? void 0 : (_state$account10$aadR3 = _state$account10$aadR2.idToken) === null || _state$account10$aadR3 === void 0 ? void 0 : _state$account10$aadR3.signInName);

              if (loyaltyEmail) {
                _context.next = 9;
                break;
              }

              return _context.abrupt("return", Promise.resolve(false));

            case 9:
              data = {
                loyaltyId: loyaltyId,
                loyaltyEmail: loyaltyEmail
              };
              rewardsData = redeemedRewards === null || redeemedRewards === void 0 ? void 0 : redeemedRewards.checkout;

              if (!rewardsData) {
                rewardsData = {
                  LoyaltyRewardIDs: null,
                  LoyaltyCouponCodes: null,
                  LoyaltyDiscount: null,
                  LoyaltyValidationText: null
                };
              }

              return _context.abrupt("return", UTIL.apiUtil.fetchPost(url, _objectSpread(_objectSpread({}, data), rewardsData || {}), token).then(function (res) {
                if (res) {
                  dispatch(setPostLoyaltyData(data));
                  var result = {
                    success: true
                  };
                  return result || false;
                } else {
                  return false;
                }
              }).catch(function (err) {
                console.error("Error on Loyalty Data Post request: ", err);
                dispatch(receiveError(UTIL.buildError(err)));
                return 0;
              }));

            case 13:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();
};

var validateCurrentCart = function validateCurrentCart(state, dispatch) {
  var _state$account11, _state$account11$aadR;

  var routeURL = UTIL.apiUtil.API.validateCart;
  var token = (_state$account11 = state.account) === null || _state$account11 === void 0 ? void 0 : (_state$account11$aadR = _state$account11.aadResponse) === null || _state$account11$aadR === void 0 ? void 0 : _state$account11$aadR.jwtIdToken;
  return UTIL.apiUtil.fetchPost(routeURL, undefined, token).then(function (json) {
    dispatch(recieveValidateCart());
    dispatch(receiveCart(newCart(state, json.Data)));
    return true;
  }).catch(function (err) {
    dispatch(resetLoading());
    dispatch(receiveError(UTIL.buildError(constructError(err, "cb7505"))));
    return false;
  });
};

var updateCurbside = function updateCurbside(state, make, model, color) {
  return function (dispatch) {
    var _state$account12, _state$account12$aadR;

    dispatch(requestCurbside());
    var routeURL = UTIL.apiUtil.API.setCustomFields;
    var data = {
      "Make": make,
      "Model": model,
      "Color": color
    };
    var token = (_state$account12 = state.account) === null || _state$account12 === void 0 ? void 0 : (_state$account12$aadR = _state$account12.aadResponse) === null || _state$account12$aadR === void 0 ? void 0 : _state$account12$aadR.jwtIdToken;

    if (!make || !model || !color) {
      dispatch(requestValidateCart());
      return validateCurrentCart(state, dispatch);
    }

    return UTIL.apiUtil.fetchPost(routeURL, data, token).then(function (json) {
      dispatch(receiveCart(newCart(state, json.Data)));
      dispatch(recieveCurbside());
      dispatch(requestValidateCart()); //Post DeliveryMode

      return validateCurrentCart(state, dispatch);
    }).catch(function (err) {
      dispatch(receiveError(UTIL.buildError(constructError(err, "cb7505"))));
    });
  };
};

var updateMixCartCustomFields = function updateMixCartCustomFields(state) {
  return function (dispatch) {
    var _state$cart$timeWante, _state$cart$timeWante2, _state$cart$timeWante3, _state$cart$timeWante4, _state$cart$timeWante5, _state$cart$timeWante6, _state$cart$timeWante7, _state$cart$timeWante8, _state$cart$timeWante9;

    var routeURL = UTIL.apiUtil.API.setCustomFields;
    var data = {
      // TODO :: api bombs without make,model,color once api is fix only send mixed cart
      "MixedCart": "MIXED CART",
      "Make": "n/a",
      "Model": "n/a",
      "Color": "n/a"
    };
    var isSameTime = ((_state$cart$timeWante = state.cart.timeWanted) === null || _state$cart$timeWante === void 0 ? void 0 : (_state$cart$timeWante2 = _state$cart$timeWante.caterTimeWanted) === null || _state$cart$timeWante2 === void 0 ? void 0 : _state$cart$timeWante2.time) == ((_state$cart$timeWante3 = state.cart.timeWanted) === null || _state$cart$timeWante3 === void 0 ? void 0 : (_state$cart$timeWante4 = _state$cart$timeWante3.foodTimeWanted) === null || _state$cart$timeWante4 === void 0 ? void 0 : _state$cart$timeWante4.time);
    var isSameDate = ((_state$cart$timeWante5 = state.cart.timeWanted) === null || _state$cart$timeWante5 === void 0 ? void 0 : (_state$cart$timeWante6 = _state$cart$timeWante5.caterTimeWanted) === null || _state$cart$timeWante6 === void 0 ? void 0 : _state$cart$timeWante6.date) == ((_state$cart$timeWante7 = state.cart.timeWanted) === null || _state$cart$timeWante7 === void 0 ? void 0 : (_state$cart$timeWante8 = _state$cart$timeWante7.foodTimeWanted) === null || _state$cart$timeWante8 === void 0 ? void 0 : _state$cart$timeWante8.date);

    if (state.cart.isFood && state.cart.isCatering && isSameDate && isSameTime && ((_state$cart$timeWante9 = state.cart.timeWanted) === null || _state$cart$timeWante9 === void 0 ? void 0 : _state$cart$timeWante9.foodTimeWanted) != null) {
      var _state$account13, _state$account13$aadR;

      var token = (_state$account13 = state.account) === null || _state$account13 === void 0 ? void 0 : (_state$account13$aadR = _state$account13.aadResponse) === null || _state$account13$aadR === void 0 ? void 0 : _state$account13$aadR.jwtIdToken;
      return UTIL.apiUtil.fetchPost(routeURL, data, token).then(function (json) {
        dispatch(receiveCart(newCart(state, json.Data)));
      }).catch(function (err) {
        dispatch(receiveError(UTIL.buildError(constructError(err))));
      });
    } else {
      return Promise.resolve('Success').then(function (value) {//console.log("condition not met for mixed cart");
      }, function (value) {});
    }
  };
};

var postDelivery = function postDelivery(deliveryMode, state) {
  return function (dispatch) {
    var _state$account14, _state$account14$aadR;

    if (state.retail.isDeliveryModeGetting) {
      return new Promise(function (resolve) {
        return resolve();
      });
    }

    dispatch(requestDeliveryMode());
    var routeURL = UTIL.apiUtil.API.setDelivery;
    var foodMethod = deliveryMode.foodDeliveryMode;
    var caterMethod = deliveryMode.caterDeliveryMode;
    var data = {
      "foodDeliveryMode": state.cart.isFood ? foodMethod ? foodMethod : "" : "",
      "caterDeliveryMode": state.cart.isCatering ? caterMethod ? caterMethod : "" : ""
    };
    var gtmdata = {
      gtm: {
        uniqueEventId: '109',
        foodDeliveryOption: foodMethod,
        caterDeliveryMethod: caterMethod,
        elementId: "post-delivery-mode"
      },
      event: 'gtm.post'
    };
    gaTracker(gtmdata);

    if ((caterMethod === "dispatch" || caterMethod === "delivery") && state.cart.isCatering) {
      data.caterDeliveryMode = "delivery";
    }

    var token = (_state$account14 = state.account) === null || _state$account14 === void 0 ? void 0 : (_state$account14$aadR = _state$account14.aadResponse) === null || _state$account14$aadR === void 0 ? void 0 : _state$account14$aadR.jwtIdToken;
    return UTIL.apiUtil.fetchPost(routeURL, data, token).then(function (json) {
      dispatch(receiveCart(newCart(state, json.Data)));
      return dispatch(recieveDeliveryMode({
        deliveryMode: deliveryMode
      }));
    }).catch(function (err) {
      console.error(err, "POSTDELIVERYERR");
      var message = UTIL.buildInternalError('cb7503');
      dispatch(requestDeliveryInfoFail());
      dispatch(receiveError(UTIL.buildError(message)));
      throw "Error";
    });
  };
};

var postTipFunction = function postTipFunction(state, amount, percent) {
  return function (dispatch) {
    var _state$account15, _state$account15$aadR;

    dispatch(requestPostTip());
    var routeURL = UTIL.apiUtil.API.setTip;
    var data = {
      amount: amount,
      tipPercentage: String(percent)
    };
    var token = (_state$account15 = state.account) === null || _state$account15 === void 0 ? void 0 : (_state$account15$aadR = _state$account15.aadResponse) === null || _state$account15$aadR === void 0 ? void 0 : _state$account15$aadR.jwtIdToken;
    return UTIL.apiUtil.fetchPost(routeURL, data, token).then(function (json) {
      dispatch(recievePostTip());
      dispatch(receiveCart(newCart(state, json.Data)));
    }).catch(function (err) {
      dispatch(recievePostTip());
      dispatch(receiveError(UTIL.buildError(constructError(err, "cb7505"))));
    });
  };
};

var getDeliveryOptionsFunction = function getDeliveryOptionsFunction(state) {
  return function (dispatch) {
    var _state$location, _state$location$locat, _state$location2, _state$location2$loca, _state$location3, _state$location3$loca, _state$location4, _state$location4$loca;

    dispatch(requestDeliveryModeOptions());
    var storeId = (state === null || state === void 0 ? void 0 : (_state$location = state.location) === null || _state$location === void 0 ? void 0 : (_state$location$locat = _state$location.location) === null || _state$location$locat === void 0 ? void 0 : _state$location$locat.olo_unique_name) || ((_state$location2 = state.location) === null || _state$location2 === void 0 ? void 0 : (_state$location2$loca = _state$location2.location) === null || _state$location2$loca === void 0 ? void 0 : _state$location2$loca.oloUniqueName);
    var caterStoreId = (state === null || state === void 0 ? void 0 : (_state$location3 = state.location) === null || _state$location3 === void 0 ? void 0 : (_state$location3$loca = _state$location3.location) === null || _state$location3$loca === void 0 ? void 0 : _state$location3$loca.olo_catering_unique_name) || ((_state$location4 = state.location) === null || _state$location4 === void 0 ? void 0 : (_state$location4$loca = _state$location4.location) === null || _state$location4$loca === void 0 ? void 0 : _state$location4$loca.oloCateringUniqueName);

    if (window.location.href.indexOf('localhost:9009') > -1) {
      return Promise.resolve(false);
    }

    var routeURL = "".concat(UTIL.apiUtil.API.getDeliveryModes);
    var getStoreInfo = UTIL.apiUtil.fetchGet("".concat(routeURL, "/").concat(storeId)).then(function (json) {
      return json.DeliveryModes;
    }).catch(function (err) {
      throw err;
    });
    var getStoreInfoCater = UTIL.apiUtil.fetchGet("".concat(routeURL, "/").concat(caterStoreId)).then(function (json) {
      return json.DeliveryModes;
    }).catch(function (err) {
      throw err;
    });
    Promise.all([getStoreInfo, getStoreInfoCater]).then(function (res) {
      dispatch(recieveDeliveryModeOptions({
        deliveryModes: {
          cater: res[1],
          food: res[0]
        }
      }));
    }).catch(function (err) {
      return dispatch(receiveError(UTIL.buildError(constructError(err))));
    });
  };
};

var setPromoCode = function setPromoCode(state, promoCode) {
  return function (dispatch) {
    var _state$account16, _state$account16$aadR;

    dispatch(requestPromoCode());
    var routeURL = UTIL.apiUtil.API.setPromoCode;
    var data = {
      "couponcode": promoCode
    };
    var token = (_state$account16 = state.account) === null || _state$account16 === void 0 ? void 0 : (_state$account16$aadR = _state$account16.aadResponse) === null || _state$account16$aadR === void 0 ? void 0 : _state$account16$aadR.jwtIdToken;
    return UTIL.apiUtil.fetchPost(routeURL, data, token).then(function (json) {
      dispatch(recievePromoCode(promoCode));
      dispatch(receiveCart(newCart(state, json.Data)));
    }).catch(function (err) {
      dispatch(resetLoading());
      dispatch(receiveError(UTIL.buildError(constructError(err, "cb7505"))));
    });
  };
};

var deletePromoCode = function deletePromoCode(promoCode) {
  return function (dispatch, getState) {
    var _state$account17, _state$account17$aadR;

    dispatch(requestPromoCode());
    var routeURL = UTIL.apiUtil.API.deletePromoCode;
    var state = getState();
    var token = (_state$account17 = state.account) === null || _state$account17 === void 0 ? void 0 : (_state$account17$aadR = _state$account17.aadResponse) === null || _state$account17$aadR === void 0 ? void 0 : _state$account17$aadR.jwtIdToken;
    return UTIL.apiUtil.fetchDelete(routeURL, {
      "couponCode": promoCode
    }, token).then(function (json) {
      dispatch(removePromoCode(promoCode));
      dispatch(receiveCart(newCart(getState(), json.Data)));
    }).catch(function (err) {
      dispatch(resetLoading());
      dispatch(receiveError(UTIL.buildError(constructError(err, "cb7505"))));
    });
  };
};

var validateOrderFunc = function validateOrderFunc(state, payload) {
  return function (dispatch) {
    if (state.cart.isRetail) {
      return new Promise(function (resolve) {
        return resolve(dispatch(recieveValidateCart()));
      });
    } else {
      return new Promise(function (resolve) {
        return resolve(dispatch(updateCurbside(state, payload.curbsideMake, payload.curbsideModel, payload.curbsideColor)));
      });
    }
  };
};

function sha256(_x2) {
  return _sha.apply(this, arguments);
}

function _sha() {
  _sha = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee13(email) {
    var encoder, data, hashBuffer, hashArray, hashHex;
    return _regeneratorRuntime.wrap(function _callee13$(_context13) {
      while (1) {
        switch (_context13.prev = _context13.next) {
          case 0:
            encoder = new TextEncoder();
            data = encoder.encode(email); // Use the Web Cryptography API to hash the data

            _context13.next = 4;
            return crypto.subtle.digest('SHA-256', data);

          case 4:
            hashBuffer = _context13.sent;
            // Convert the result to a hex string
            hashArray = Array.from(new Uint8Array(hashBuffer));
            hashHex = hashArray.map(function (byte) {
              return byte.toString(16).padStart(2, '0');
            }).join('');
            return _context13.abrupt("return", hashHex);

          case 8:
          case "end":
            return _context13.stop();
        }
      }
    }, _callee13);
  }));
  return _sha.apply(this, arguments);
}

var submitOrder = function submitOrder(state, payload) {
  return /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(dispatch) {
      var _state$account18, _state$account18$aadR;

      var routeURL, token, emailHash, json, errorMsg;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              dispatch(requestSubmitCart());
              routeURL = UTIL.apiUtil.API.submitCart;
              token = (_state$account18 = state.account) === null || _state$account18 === void 0 ? void 0 : (_state$account18$aadR = _state$account18.aadResponse) === null || _state$account18$aadR === void 0 ? void 0 : _state$account18$aadR.jwtIdToken;
              console.log({
                PurchaseState: state,
                PurchaseData: payload
              });
              _context2.prev = 4;
              _context2.next = 7;
              return sha256(payload === null || payload === void 0 ? void 0 : payload.emailAddress);

            case 7:
              emailHash = _context2.sent;
              _context2.next = 10;
              return UTIL.apiUtil.fetchPost(routeURL, payload, token).then(function (json) {
                var _cartInfo$priceInfo$s = {
                  cartInfo: state.cart.cart,
                  priceInfo: state.cart.price,
                  submitInfo: json.Data,
                  foodInfo: state.cart.food,
                  caterInfo: state.cart.cater,
                  retailInfo: state.cart.retail,
                  location: state.location.location,
                  userInfo: {
                    type: payload.userType,
                    billingMethod: payload.billingMethod,
                    billingZip: payload.billingZip,
                    email_sha256: emailHash
                  },
                  rewardsInfo: state.rewards
                },
                    cartInfo = _cartInfo$priceInfo$s.cartInfo,
                    priceInfo = _cartInfo$priceInfo$s.priceInfo,
                    submitInfo = _cartInfo$priceInfo$s.submitInfo,
                    foodInfo = _cartInfo$priceInfo$s.foodInfo,
                    caterInfo = _cartInfo$priceInfo$s.caterInfo,
                    retailInfo = _cartInfo$priceInfo$s.retailInfo,
                    location = _cartInfo$priceInfo$s.location,
                    userInfo = _cartInfo$priceInfo$s.userInfo,
                    rewardsInfo = _cartInfo$priceInfo$s.rewardsInfo;
                purchaseConfirmation({
                  cartInfo: cartInfo,
                  priceInfo: priceInfo,
                  submitInfo: submitInfo,
                  foodInfo: foodInfo,
                  caterInfo: caterInfo,
                  retailInfo: retailInfo,
                  location: location,
                  userInfo: userInfo
                });
                var items = cartInfo === null || cartInfo === void 0 ? void 0 : cartInfo.map(function (cartLine, index) {
                  var _rewardsInfo$rewardsR, _rewardsInfo$rewardsR2, _rewardsInfo$rewardsR3;

                  var product = (cartLine === null || cartLine === void 0 ? void 0 : cartLine.Product) || {};
                  var rewardCart = rewardsInfo === null || rewardsInfo === void 0 ? void 0 : (_rewardsInfo$rewardsR = rewardsInfo.rewardsRedemptionResponse) === null || _rewardsInfo$rewardsR === void 0 ? void 0 : (_rewardsInfo$rewardsR2 = _rewardsInfo$rewardsR.redeemOptions) === null || _rewardsInfo$rewardsR2 === void 0 ? void 0 : (_rewardsInfo$rewardsR3 = _rewardsInfo$rewardsR2[0]) === null || _rewardsInfo$rewardsR3 === void 0 ? void 0 : _rewardsInfo$rewardsR3.cart;
                  var isReward = rewardCart === null || rewardCart === void 0 ? void 0 : rewardCart.some(function (redeemedItem) {
                    return redeemedItem.productChainId === (product === null || product === void 0 ? void 0 : product.ProductChainId) || (product === null || product === void 0 ? void 0 : product.ProductId);
                  });
                  var categories = UTIL.getSectionCategorySubCat(product.DetailLink) || [];
                  categories[0] = pageCategoryNames[categories === null || categories === void 0 ? void 0 : categories[0]];
                  return UTIL.itemObject({
                    index: index,
                    affiliation: categories === null || categories === void 0 ? void 0 : categories[0],
                    price: calculateProductPriceWithoutQuantity((cartLine === null || cartLine === void 0 ? void 0 : cartLine.LineCost) || (product === null || product === void 0 ? void 0 : product.AdjustedPrice) || "", (cartLine === null || cartLine === void 0 ? void 0 : cartLine.Quantity) || ""),
                    item_id: (product === null || product === void 0 ? void 0 : product.ProductChainId) || (product === null || product === void 0 ? void 0 : product.ProductId),
                    item_name: (product === null || product === void 0 ? void 0 : product.DisplayName) || "",
                    item_category: categories,
                    item_variant: (product === null || product === void 0 ? void 0 : product.ProductVariantModel) || "",
                    quantity: (cartLine === null || cartLine === void 0 ? void 0 : cartLine.Quantity) || "",
                    sku: (product === null || product === void 0 ? void 0 : product.ProductChainId) || (product === null || product === void 0 ? void 0 : product.ProductId),
                    reward_applied: isReward
                  });
                });
                var event = UTIL.purchaseEvent({
                  currency: "USD",
                  items: items,
                  shipping: priceInfo === null || priceInfo === void 0 ? void 0 : priceInfo.ShippingTotal,
                  tax: priceInfo === null || priceInfo === void 0 ? void 0 : priceInfo.TaxTotal,
                  transaction_id: (submitInfo === null || submitInfo === void 0 ? void 0 : submitInfo.FoodOrderId) || (submitInfo === null || submitInfo === void 0 ? void 0 : submitInfo.CateringOrderId) || (submitInfo === null || submitInfo === void 0 ? void 0 : submitInfo.RetailOrderId) || "",
                  value: (priceInfo === null || priceInfo === void 0 ? void 0 : priceInfo.Total) || "",
                  payment_method: userInfo === null || userInfo === void 0 ? void 0 : userInfo.billingMethod
                }); // Clear out the ecomm object first

                UTIL.sendToGTM({
                  data: {
                    ecommerce: null
                  }
                });
                UTIL.sendToGTM({
                  data: event
                });
                return json;
              });

            case 10:
              json = _context2.sent;
              _context2.next = 13;
              return dispatch(recieveSubmitCart({
                submitInfo: json.Data,
                paymentInfo: payload
              }));

            case 13:
              return _context2.abrupt("return", true);

            case 16:
              _context2.prev = 16;
              _context2.t0 = _context2["catch"](4);
              errorMsg = UTIL.buildError(constructError(_context2.t0, "cb7505"));
              UTIL.orderError({
                message: errorMsg || 'Unknown Error'
              });
              dispatch(resetLoading());
              dispatch(receiveError(errorMsg));
              return _context2.abrupt("return", false);

            case 23:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[4, 16]]);
    }));

    return function (_x3) {
      return _ref2.apply(this, arguments);
    };
  }();
};

var clearCart = function clearCart(state) {
  return function (dispatch) {
    var _state$account19, _state$account19$aadR;

    dispatch(requestClearCart());
    var storeId = UTIL.getStoreId(state);
    var routeURL = UTIL.apiUtil.API.cart.deleteAll;
    var data = {
      storeId: storeId
    };
    var token = (_state$account19 = state.account) === null || _state$account19 === void 0 ? void 0 : (_state$account19$aadR = _state$account19.aadResponse) === null || _state$account19$aadR === void 0 ? void 0 : _state$account19$aadR.jwtIdToken; //Delete cart

    return UTIL.apiUtil.fetchDelete(routeURL, data, token).then(function () {
      return dispatch(recieveClearCart());
    }).catch(function (err) {
      dispatch(resetLoading());
      return dispatch(receiveError(UTIL.buildError(constructError(err))));
    });
  };
};

var getGiftcardBalance = function getGiftcardBalance(state, giftCardObj) {
  return function (dispatch) {
    var _state$account20, _state$account20$aadR;

    dispatch(requestGiftCard()); //const routeURL = `${UTIL.apiUtil.API.cart.getSchemaNumber}/${state.cart.giftCardScheme}/balance`;

    var routeURL = "".concat(UTIL.apiUtil.API.worldPay.giftCardBalance);
    var data = {
      "GiftCardNumber": giftCardObj.num,
      "GiftCardPin": giftCardObj.pin
    };
    var token = (_state$account20 = state.account) === null || _state$account20 === void 0 ? void 0 : (_state$account20$aadR = _state$account20.aadResponse) === null || _state$account20$aadR === void 0 ? void 0 : _state$account20$aadR.jwtIdToken; //GetGiftCardBalance

    return UTIL.apiUtil.fetchPost(routeURL, data, token).then(function (json) {
      var pascal = toPascal(json);
      var price = state.cart.price; //Will have to refactor, remaining/used

      var Remaining = pascal.Balance ? Math.max(0, price.Total - pascal.Balance) : undefined;
      var Used = pascal.Balance ? Math.min(price.Total, pascal.Balance) : undefined;
      var giftCards = Array.isArray(state.cart.giftCardInfo) ? state.cart.giftCardInfo : [];
      dispatch(recieveGiftCard({
        giftCardInfo: {
          balance: pascal.Balance,
          num: data.GiftCardNumber,
          pin: data.GiftCardPin
        },
        price: _objectSpread(_objectSpread({}, state.cart.price), {}, {
          Remaining: Remaining,
          Used: Used
        })
      }));
      return pascal.Balance;
    }).catch(function (err) {
      dispatch(resetLoading());
      dispatch(receiveError(UTIL.buildError(constructError({
        Errors: [err.Message || err.message]
      }, "cb7508"))));
      throw "Gift Card Error";
    });
  };
};

var getGiftcardBalanceWP = function getGiftcardBalanceWP(state, giftCardObj) {
  return function (dispatch) {
    dispatch(resetError());
    dispatch(requestGiftCard());
    var routeURL = "".concat(UTIL.apiUtil.API.worldPay.giftCardBalance);
    var data = {
      "GiftCardNumber": giftCardObj.num,
      "GiftCardPin": giftCardObj.pin
    };

    if (state.cart.giftCardInfo.find(function (item) {
      return item.num === giftCardObj.num;
    })) {
      dispatch(receiveError(UTIL.buildError(constructError({
        Errors: ["Gift card already applied."]
      }, "cb7602"))));
      throw "Gift Card Error";
    } //GetGiftCardBalance


    return UTIL.apiUtil.fetchPost(routeURL, data).then(function (json) {
      var pascal = toPascal(json);
      var balance = pascal === null || pascal === void 0 ? void 0 : pascal.Balance;
      var price = state.cart.price; // const Remaining = (balance) ? Math.max(0, price.Total - balance) : undefined;
      // const Used = (balance) ? Math.min(price.Total, balance) : undefined;

      var giftCards = Array.isArray(state.cart.giftCardInfo) ? state.cart.giftCardInfo : [];
      var Remaining = (price === null || price === void 0 ? void 0 : price.Remaining) || null;
      var Used = 0;
      var remaining = balance ? Math.max(0, Remaining - balance) : undefined;
      var used = balance ? Math.min(Remaining, balance) : undefined;

      if (giftCards.length) {
        giftCards.map(function (el, i) {
          remaining = el.balance ? Math.max(0, remaining - el.balance) : undefined;
          used += el.balance ? Math.min(remaining, el.balance) : undefined;
        }); // remaining += (balance) ? Math.max(0, price.Total - balance) : undefined;
        // used += (balance) ? Math.min(price.Total, balance) : undefined;
      } else {// remaining = (balance) ? Math.max(0, price.Total - balance) : undefined;
          // used = (balance) ? Math.min(price.Total, balance) : undefined;
        }

      dispatch(recieveGiftCard({
        giftCardInfo: [].concat(_toConsumableArray(giftCards), [{
          balance: balance,
          num: data.GiftCardNumber,
          pin: data.GiftCardPin
        }]),
        price: _objectSpread(_objectSpread({}, state.cart.price), {}, {
          Remaining: remaining,
          Used: used
        })
      }));
      return balance;
    }).catch(function (err) {
      console.error(err, "ERROR", "giftcardError");
      dispatch(receiveError(UTIL.buildError(constructError({
        Errors: ["Gift card balance cannot be retrieved."]
      }, "cb7603"))));
      throw "Retail Gift Card Error";
    });
  };
};

var getGiftCardSchema = function getGiftCardSchema() {
  return function (dispatch) {
    var _account$aadResponse;

    dispatch(requestGiftCardScheme());

    if (window.location.href.indexOf("localhost:9009") > -1) {
      var _billingSchemes$Billi, _billingSchemes$Billi2, _billingSchemes$Billi3, _billingSchemes$Billi4, _giftScheme$, _ccScheme$, _applePayScheme$, _googlePayScheme$;

      var giftScheme = Array.isArray(billingSchemes.BillingSchemes) ? (_billingSchemes$Billi = billingSchemes.BillingSchemes) === null || _billingSchemes$Billi === void 0 ? void 0 : _billingSchemes$Billi.filter(function (scheme) {
        return scheme.Type === "giftcard";
      }) : [];
      var ccScheme = Array.isArray(billingSchemes.BillingSchemes) ? (_billingSchemes$Billi2 = billingSchemes.BillingSchemes) === null || _billingSchemes$Billi2 === void 0 ? void 0 : _billingSchemes$Billi2.filter(function (scheme) {
        return scheme.Type === "creditcard";
      }) : [];
      var applePayScheme = Array.isArray(billingSchemes.BillingSchemes) ? (_billingSchemes$Billi3 = billingSchemes.BillingSchemes) === null || _billingSchemes$Billi3 === void 0 ? void 0 : _billingSchemes$Billi3.filter(function (scheme) {
        var _scheme$Name, _scheme$Name$toLowerC;

        return scheme.Type === "external" && ((_scheme$Name = scheme.Name) === null || _scheme$Name === void 0 ? void 0 : (_scheme$Name$toLowerC = _scheme$Name.toLowerCase()) === null || _scheme$Name$toLowerC === void 0 ? void 0 : _scheme$Name$toLowerC.indexOf('apple')) > -1;
      }) : [];
      var googlePayScheme = Array.isArray(billingSchemes.BillingSchemes) ? (_billingSchemes$Billi4 = billingSchemes.BillingSchemes) === null || _billingSchemes$Billi4 === void 0 ? void 0 : _billingSchemes$Billi4.filter(function (scheme) {
        var _scheme$Name2, _scheme$Name2$toLower;

        return scheme.Type === "external" && ((_scheme$Name2 = scheme.Name) === null || _scheme$Name2 === void 0 ? void 0 : (_scheme$Name2$toLower = _scheme$Name2.toLowerCase()) === null || _scheme$Name2$toLower === void 0 ? void 0 : _scheme$Name2$toLower.indexOf('google')) > -1;
      }) : [];
      var giftSchemeId = (giftScheme === null || giftScheme === void 0 ? void 0 : giftScheme.length) ? (_giftScheme$ = giftScheme[0]) === null || _giftScheme$ === void 0 ? void 0 : _giftScheme$.Id : null;
      var ccSchemeId = (ccScheme === null || ccScheme === void 0 ? void 0 : ccScheme.length) ? (_ccScheme$ = ccScheme[0]) === null || _ccScheme$ === void 0 ? void 0 : _ccScheme$.Id : 1;
      var applePaySchemeId = (applePayScheme === null || applePayScheme === void 0 ? void 0 : applePayScheme.length) ? (_applePayScheme$ = applePayScheme[0]) === null || _applePayScheme$ === void 0 ? void 0 : _applePayScheme$.Id : null;
      var googlePaySchemeId = (googlePayScheme === null || googlePayScheme === void 0 ? void 0 : googlePayScheme.length) ? (_googlePayScheme$ = googlePayScheme[0]) === null || _googlePayScheme$ === void 0 ? void 0 : _googlePayScheme$.Id : null;
      return dispatch(recieveGiftCardScheme({
        giftCardScheme: giftSchemeId,
        ccScheme: ccSchemeId,
        applePayScheme: applePaySchemeId,
        googlePayScheme: googlePaySchemeId
      }));
    }

    var routeURL = UTIL.apiUtil.API.cart.getSchemaNumber; //getbillingSchemes

    var account = getSessionStorageKey('account');
    var token = account === null || account === void 0 ? void 0 : (_account$aadResponse = account.aadResponse) === null || _account$aadResponse === void 0 ? void 0 : _account$aadResponse.jwtIdToken;
    return UTIL.apiUtil.fetchGet(routeURL, token).then(function (json) {
      var _json$BillingSchemes, _json$BillingSchemes2, _json$BillingSchemes3, _json$BillingSchemes4, _giftScheme$2, _ccScheme$2, _applePayScheme$2, _googlePayScheme$2;

      if (json.errorMessage) throw json.errorMessage;
      var giftScheme = Array.isArray(json.BillingSchemes) ? (_json$BillingSchemes = json.BillingSchemes) === null || _json$BillingSchemes === void 0 ? void 0 : _json$BillingSchemes.filter(function (scheme) {
        return scheme.Type === "giftcard";
      }) : [];
      var ccScheme = Array.isArray(json.BillingSchemes) ? (_json$BillingSchemes2 = json.BillingSchemes) === null || _json$BillingSchemes2 === void 0 ? void 0 : _json$BillingSchemes2.filter(function (scheme) {
        return scheme.Type === "creditcard";
      }) : [];
      var applePayScheme = Array.isArray(json.BillingSchemes) ? (_json$BillingSchemes3 = json.BillingSchemes) === null || _json$BillingSchemes3 === void 0 ? void 0 : _json$BillingSchemes3.filter(function (scheme) {
        var _scheme$Name3, _scheme$Name3$toLower;

        return scheme.Type === "external" && ((_scheme$Name3 = scheme.Name) === null || _scheme$Name3 === void 0 ? void 0 : (_scheme$Name3$toLower = _scheme$Name3.toLowerCase()) === null || _scheme$Name3$toLower === void 0 ? void 0 : _scheme$Name3$toLower.indexOf('apple')) > -1;
      }) : [];
      var googlePayScheme = Array.isArray(json.BillingSchemes) ? (_json$BillingSchemes4 = json.BillingSchemes) === null || _json$BillingSchemes4 === void 0 ? void 0 : _json$BillingSchemes4.filter(function (scheme) {
        var _scheme$Name4, _scheme$Name4$toLower;

        return scheme.Type === "external" && ((_scheme$Name4 = scheme.Name) === null || _scheme$Name4 === void 0 ? void 0 : (_scheme$Name4$toLower = _scheme$Name4.toLowerCase()) === null || _scheme$Name4$toLower === void 0 ? void 0 : _scheme$Name4$toLower.indexOf('google')) > -1;
      }) : [];
      var giftSchemeId = (giftScheme === null || giftScheme === void 0 ? void 0 : giftScheme.length) ? (_giftScheme$2 = giftScheme[0]) === null || _giftScheme$2 === void 0 ? void 0 : _giftScheme$2.Id : null;
      var ccSchemeId = (ccScheme === null || ccScheme === void 0 ? void 0 : ccScheme.length) ? (_ccScheme$2 = ccScheme[0]) === null || _ccScheme$2 === void 0 ? void 0 : _ccScheme$2.Id : 1;
      var applePaySchemeId = (applePayScheme === null || applePayScheme === void 0 ? void 0 : applePayScheme.length) ? (_applePayScheme$2 = applePayScheme[0]) === null || _applePayScheme$2 === void 0 ? void 0 : _applePayScheme$2.Id : null;
      var googlePaySchemeId = (googlePayScheme === null || googlePayScheme === void 0 ? void 0 : googlePayScheme.length) ? (_googlePayScheme$2 = googlePayScheme[0]) === null || _googlePayScheme$2 === void 0 ? void 0 : _googlePayScheme$2.Id : null;
      return dispatch(recieveGiftCardScheme({
        giftCardScheme: giftSchemeId,
        ccScheme: ccSchemeId,
        applePayScheme: applePaySchemeId,
        googlePayScheme: googlePaySchemeId
      }));
    }).catch(function (err) {
      var code = "cb7507"; //Forcing to 188 if err'ed

      if (err.code === 7) {
        dispatch(recieveGiftCardScheme({
          giftCardScheme: null,
          ccScheme: 1,
          applePayScheme: null,
          googlePayScheme: null
        }));
        dispatch(receiveError(UTIL.buildError(constructError(err, code))));
      } else {
        console.error(err, "ERROR, getGiftCardSchema, DEFAULT RESULTS");
        dispatch(recieveGiftCardScheme({
          giftCardScheme: null,
          ccScheme: 1,
          applePayScheme: null,
          googlePayScheme: null
        }));
        dispatch(receiveError(UTIL.buildError(constructError(err, code))));
      }

      throw err;
    });
  };
};

var fetchGetSavedCreditCards = function fetchGetSavedCreditCards(state) {
  return function (dispatch) {
    var _state$account21, _state$account21$aadR;

    dispatch(requestGiftCardScheme());
    var routeURL = UTIL.apiUtil.API.worldPay.getSavedCards;
    var token = (_state$account21 = state.account) === null || _state$account21 === void 0 ? void 0 : (_state$account21$aadR = _state$account21.aadResponse) === null || _state$account21$aadR === void 0 ? void 0 : _state$account21$aadR.jwtIdToken; //getbillingSchemes

    return UTIL.apiUtil.fetchGet(routeURL, token).then(function (json) {
      if (json.errorMessage) throw json.errorMessage;
      return dispatch(recieveSavedCards({
        savedCards: json
      }));
    }).catch(function (err) {
      console.error(err, "SCHEMA ERROR"); //dispatch(receiveError(UTIL.buildError(constructError({Errors:[err]}))))

      throw err;
    });
  };
};

var getExcludedTimes = function getExcludedTimes() {
  var location = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "sacramento-ca-catering";
  var date = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 20201125;
  var routeURL = "".concat(UTIL.apiUtil.API.cart.getUnvabilableTimeslots, "?storeId=").concat(location, "&date=").concat(date); //getbillingSchemes

  return UTIL.apiUtil.fetchGet(routeURL).then(function (json) {
    if (json.errorMessage) throw json.errorMessage;
    return json;
  }).catch(function (err) {
    console.error(err, "excludedError ERROR"); // dispatch(receiveError(UTIL.buildError()))

    throw err;
  });
};

var fetchTokenExAuthToken = function fetchTokenExAuthToken(state) {
  return /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(dispatch) {
      var getTokenExAuthTokenUrl;
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              getTokenExAuthTokenUrl = UTIL.apiUtil.generateUrl('token-ex-api', 'getAuthToken');
              return _context3.abrupt("return", axios({
                method: 'get',
                headers: UTIL.apiUtil.setHeaders(),
                url: getTokenExAuthTokenUrl
              }).then(function (json) {
                return dispatch(recieveTokenExAuthKey(json.data));
              }).catch(function (err) {
                dispatch(resetError());
                var errorState = UTIL.buildError(err);
                return dispatch(receiveError(errorState));
              }));

            case 2:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    return function (_x4) {
      return _ref3.apply(this, arguments);
    };
  }();
};

var getCart = function getCart(jwtIdToken) {
  return function (dispatch, getState) {
    return dispatch(fetchCart(getState(), jwtIdToken));
  };
};

var checkGiftCard = function checkGiftCard(giftCardObj) {
  return function (dispatch, getState) {
    //return dispatch(getGiftcardBalanceWP(getState(), giftCardObj));
    if (getState().cart.isRetail) {
      return dispatch(getGiftcardBalanceWP(getState(), giftCardObj));
    } else {
      return dispatch(getGiftcardBalance(getState(), giftCardObj));
    }
  };
};

var postItem = function postItem(postData) {
  return function (dispatch, getState) {
    return dispatch(postItemSend(getState(), postData));
  };
};

var deleteLine = function deleteLine(lineId) {
  return function (dispatch, getState) {
    return dispatch(deleteCartSend(getState(), lineId));
  };
};

var patchLine = function patchLine(lineId, options, newQuantity) {
  var newItem = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var isDetail = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
  var addOn = arguments.length > 5 ? arguments[5] : undefined;
  return function (dispatch, getState) {
    return dispatch(updateCartLine(getState(), lineId, options, newQuantity, newItem, isDetail, addOn));
  };
};

var postDeliveryMode = function postDeliveryMode(deliveryMode) {
  return function (dispatch, getState) {
    return dispatch(postDelivery(deliveryMode, getState()));
  };
};

var setTimeWanted = function setTimeWanted(timeObj) {
  return function (dispatch, getState) {
    return dispatch(updateTimeWanted(getState(), timeObj));
  };
};

var setDeliveryInfo = function setDeliveryInfo(deliveryState, street1, street2, city, zip, phone, special, deliveryMode) {
  return function (dispatch, getState) {
    return dispatch(updateDeliveryInfo(getState(), deliveryState, street1, street2, city, zip, phone, special, deliveryMode)).catch(function (err) {
      throw err;
    });
  };
};

var setRetail = function setRetail(addressInfo, deliveryMode) {
  return function (dispatch, getState) {
    return dispatch(postRetailOrder(getState(), addressInfo, deliveryMode)).catch(function (err) {
      throw err;
    });
  };
};

var submitCart = function submitCart(payload) {
  return function (dispatch, getState) {
    return dispatch(submitOrder(getState(), payload));
  };
};

var resetGoToCheckout = function resetGoToCheckout() {
  var toggle = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  return function (dispatch) {
    return dispatch(hitCheckout({
      goToCheckout: toggle
    }));
  };
};

var saveDeliveryMode = function saveDeliveryMode(mode) {
  return function (dispatch, getState) {
    return dispatch(storeDeliveryMode({
      deliveryMode: mode
    }));
  };
};

var saveForEdit = function saveForEdit(itemToSave, link) {
  return function (dispatch) {
    dispatch(actionSaveForEdit({
      saveForEdit: itemToSave
    }));
    setTimeout(function () {
      return window.location.replace(link);
    }, 100);
  };
};

var getDeliveryOptions = function getDeliveryOptions() {
  return function (dispatch, getState) {
    return dispatch(getDeliveryOptionsFunction(getState()));
  };
};

var postTip = function postTip(amount, percent) {
  return function (dispatch, getState) {
    return dispatch(postTipFunction(getState(), amount, percent));
  };
};

var postPromoCode = function postPromoCode(promoCode) {
  return function (dispatch, getState) {
    return dispatch(setPromoCode(getState(), promoCode));
  };
};

var setCurbside = function setCurbside(make, model, color, deliveryMode) {
  return function (dispatch, getState) {
    return dispatch(updateCurbside(getState(), make, model, color)).then(function () {
      return dispatch(postDelivery(deliveryMode, getState(), "curbside"));
    });
  };
};

var setMixCartCustomFields = function setMixCartCustomFields() {
  return function (dispatch, getState) {
    return dispatch(updateMixCartCustomFields(getState()));
  };
};

var dumpCart = function dumpCart() {
  return function (dispatch, getState) {
    return dispatch(clearCart(getState()));
  };
};

var validateOrder = function validateOrder(payload) {
  return function (dispatch, getState) {
    return dispatch(validateOrderFunc(getState(), payload));
  };
};

var removeGiftCard = function removeGiftCard() {
  var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  return function (dispatch, getState) {
    var state = getState();
    var giftCardInfo = state.cart.giftCardInfo || [];
    var curr = giftCardInfo[index];
    var price = state.cart.price;

    if (state.cart.isRetail) {
      return dispatch(recieveGiftCard({
        giftCardInfo: drop(giftCardInfo, index),
        price: _objectSpread(_objectSpread({}, price), {}, {
          Remaining: price.Remaining + curr.balance,
          Used: price.Used - curr.balance
        })
      }));
    }

    return dispatch(recieveGiftCard({
      giftCardInfo: {},
      price: _objectSpread(_objectSpread({}, getState().cart.price), {}, {
        Remaining: 0,
        Used: 0
      })
    }));
  };
};

var removeAllGiftCards = function removeAllGiftCards() {
  return function (dispatch, getState) {
    var _state$cart5;

    var state = getState();
    return dispatch(recieveGiftCard({
      giftCardInfo: [],
      price: _objectSpread(_objectSpread({}, state === null || state === void 0 ? void 0 : (_state$cart5 = state.cart) === null || _state$cart5 === void 0 ? void 0 : _state$cart5.price), {}, {
        Remaining: 0,
        Used: 0
      })
    }));
  };
};

var getSavedCreditCards = function getSavedCreditCards() {
  return function (dispatch, getState) {
    return dispatch(fetchGetSavedCreditCards(getState()));
  };
};

var getTokenExToken = function getTokenExToken() {
  return function (dispatch, getState) {
    return dispatch(fetchTokenExAuthToken(getState()));
  };
};

var postNewsletter = function postNewsletter(data) {
  var apiVersion = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  return function (dispatch, getState) {
    var _state$account22, _state$account22$aadR;

    dispatch(newsLetterRequest());
    var routeURL = UTIL.apiUtil.generateUrlForceVersion('marketing', 'addNewsletter', 'v2');
    var state = getState();
    var token = (_state$account22 = state.account) === null || _state$account22 === void 0 ? void 0 : (_state$account22$aadR = _state$account22.aadResponse) === null || _state$account22$aadR === void 0 ? void 0 : _state$account22$aadR.jwtIdToken;
    var headers = UTIL.apiUtil.setHeaders();

    if (token) {
      headers.Authorization = "Bearer ".concat(token);
    }

    return axios({
      method: 'PUT',
      headers: headers,
      data: data,
      url: routeURL
    }).then(function (json) {
      dispatch(newsLetterResponse(json));
    }).catch(function (err) {
      dispatch(resetLoading());
      dispatch(receiveError(UTIL.buildError(constructError(err, "cb7505"))));
    });
  };
};

var handlePostLoyaltyData = function handlePostLoyaltyData() {
  return /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(dispatch, getState) {
      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              return _context4.abrupt("return", dispatch(postLoyaltyData(getState())));

            case 1:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }));

    return function (_x5, _x6) {
      return _ref4.apply(this, arguments);
    };
  }();
};

var calcTotals = function calcTotals(firstValue, secondValue) {
  var decimals = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 2;
  var result = parseFloat(firstValue) - parseFloat(secondValue);
  result = result.toFixed(decimals);
  return parseFloat(result);
};

var deepClone = function deepClone(obj) {
  if (obj === null || typeof obj !== 'object') {
    return obj;
  }

  var clone = Array.isArray(obj) ? [] : {};
  Object.entries(obj).forEach(function (_ref5) {
    var _ref6 = _slicedToArray(_ref5, 2),
        key = _ref6[0],
        value = _ref6[1];

    clone[key] = deepClone(value);
  });
  return clone;
};

var getDiscountAmount = function getDiscountAmount(cartItem, index, cartItemsWithRewardDiscounts, cartItemsWithPointsDiscounts) {
  var discountAmount = 0;

  if ("".concat(cartItem.Product.ProductChainId, "-").concat(index + 1) in cartItemsWithRewardDiscounts) {
    cartItemsWithRewardDiscounts["".concat(cartItem.Product.ProductChainId, "-").concat(index + 1)].forEach(function (item) {
      discountAmount += item.amount || 0;
    });
  }

  if ("".concat(cartItem.Product.ProductChainId, "-").concat(index + 1) in cartItemsWithPointsDiscounts) {
    cartItemsWithPointsDiscounts["".concat(cartItem.Product.ProductChainId, "-").concat(index + 1)].forEach(function (item) {
      discountAmount += item.amount || 0;
    });
  }

  return discountAmount;
};

function redeemRewards(state, type) {
  return /*#__PURE__*/function () {
    var _ref7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(dispatch) {
      var _rewards$redeemedRewa, _rewards$redeemedRewa2, _rewards$redeemedRewa3, _rewardsRedemption, _rewardsRedemption$re, _cart$cart;

      var cart, rewards, rewardsRedemption, newCart, totalDiscountAmount, _rewardsRedemption$re2, _cart$cartBeforeRewar, _cart$cartBeforeRewar2, _cart$cartBeforeRewar3, _cart$cartBeforeRewar4, _cart$cartBeforeRewar5, _cart$cartBeforeRewar6, _cart$cartBeforeRewar7, cartItemsWithRewardDiscounts, cartItemsWithPointsDiscounts;

      return _regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              cart = state.cart, rewards = state.rewards;

              if (!((rewards === null || rewards === void 0 ? void 0 : (_rewards$redeemedRewa = rewards.redeemedRewards) === null || _rewards$redeemedRewa === void 0 ? void 0 : _rewards$redeemedRewa.pegs) || (rewards === null || rewards === void 0 ? void 0 : (_rewards$redeemedRewa2 = rewards.redeemedRewards) === null || _rewards$redeemedRewa2 === void 0 ? void 0 : (_rewards$redeemedRewa3 = _rewards$redeemedRewa2.rewards) === null || _rewards$redeemedRewa3 === void 0 ? void 0 : _rewards$redeemedRewa3.length))) {
                _context5.next = 10;
                break;
              }

              _context5.t0 = type;
              _context5.next = _context5.t0 === "recommended" ? 5 : _context5.t0 === "custom" ? 7 : 9;
              break;

            case 5:
              rewardsRedemption = rewards.rewardsRedemptionResponse;
              return _context5.abrupt("break", 10);

            case 7:
              rewardsRedemption = rewards.customRewardsRedemptionResponse;
              return _context5.abrupt("break", 10);

            case 9:
              rewardsRedemption = null;

            case 10:
              newCart = _objectSpread({}, cart);
              newCart.cart = deepClone(cart.cartBeforeRewards.cart_org);
              newCart.price = deepClone(cart.cartBeforeRewards.price);
              newCart.destructuredCart = deepClone(cart.cartBeforeRewards.destructuredCart);
              totalDiscountAmount = 0;

              if (rewardsRedemption && ((_rewardsRedemption = rewardsRedemption) === null || _rewardsRedemption === void 0 ? void 0 : (_rewardsRedemption$re = _rewardsRedemption.redeemOptions) === null || _rewardsRedemption$re === void 0 ? void 0 : _rewardsRedemption$re[0]) && (cart === null || cart === void 0 ? void 0 : (_cart$cart = cart.cart) === null || _cart$cart === void 0 ? void 0 : _cart$cart.length) && parseFloat(cart.cartBeforeRewards.price.Subtotal) > 0) {
                cartItemsWithRewardDiscounts = [];
                cartItemsWithPointsDiscounts = [];
                (_rewardsRedemption$re2 = rewardsRedemption.redeemOptions[0].cart) === null || _rewardsRedemption$re2 === void 0 ? void 0 : _rewardsRedemption$re2.forEach(function (item) {
                  if (item.redemptionType === "rewards") {
                    if ("".concat(item.productChainId, "-").concat(item.cartLineItem) in cartItemsWithRewardDiscounts) {
                      cartItemsWithRewardDiscounts["".concat(item.productChainId, "-").concat(item.cartLineItem)].push(item);
                    } else {
                      cartItemsWithRewardDiscounts["".concat(item.productChainId, "-").concat(item.cartLineItem)] = [item];
                    }
                  } else {
                    if ("".concat(item.productChainId, "-").concat(item.cartLineItem) in cartItemsWithPointsDiscounts) {
                      cartItemsWithPointsDiscounts["".concat(item.productChainId, "-").concat(item.cartLineItem)].push(item);
                    } else {
                      cartItemsWithPointsDiscounts["".concat(item.productChainId, "-").concat(item.cartLineItem)] = [item];
                    }
                  }
                });
                cart === null || cart === void 0 ? void 0 : (_cart$cartBeforeRewar = cart.cartBeforeRewards) === null || _cart$cartBeforeRewar === void 0 ? void 0 : (_cart$cartBeforeRewar2 = _cart$cartBeforeRewar.cart_org) === null || _cart$cartBeforeRewar2 === void 0 ? void 0 : (_cart$cartBeforeRewar3 = _cart$cartBeforeRewar2.filter(function (item) {
                  return item.Product.CatalogName === 'CB_Food_Store';
                })) === null || _cart$cartBeforeRewar3 === void 0 ? void 0 : _cart$cartBeforeRewar3.forEach(function (cartItem, index) {
                  var discountAmount = getDiscountAmount(cartItem, index, cartItemsWithRewardDiscounts, cartItemsWithPointsDiscounts);
                  newCart.cart[index].Price.Subtotal = calcTotals(cartItem.Price.Subtotal, discountAmount);
                  newCart.cart[index].LineCost = calcTotals(cartItem.LineCost, discountAmount);
                  totalDiscountAmount += discountAmount;
                });
                cart === null || cart === void 0 ? void 0 : (_cart$cartBeforeRewar4 = cart.cartBeforeRewards) === null || _cart$cartBeforeRewar4 === void 0 ? void 0 : (_cart$cartBeforeRewar5 = _cart$cartBeforeRewar4.destructuredCart) === null || _cart$cartBeforeRewar5 === void 0 ? void 0 : (_cart$cartBeforeRewar6 = _cart$cartBeforeRewar5.foodItems) === null || _cart$cartBeforeRewar6 === void 0 ? void 0 : (_cart$cartBeforeRewar7 = _cart$cartBeforeRewar6.filter(function (item) {
                  return item.Product.CatalogName === 'CB_Food_Store';
                })) === null || _cart$cartBeforeRewar7 === void 0 ? void 0 : _cart$cartBeforeRewar7.forEach(function (cartItem, index) {
                  var discountAmount = getDiscountAmount(cartItem, index, cartItemsWithRewardDiscounts, cartItemsWithPointsDiscounts);
                  newCart.destructuredCart.foodItems[index].Price.Subtotal = calcTotals(cartItem.Price.Subtotal, discountAmount);
                  newCart.destructuredCart.foodItems[index].LineCost = calcTotals(cartItem.LineCost, discountAmount);
                });
                dispatch(redeemRewardsAction(newCart, true));
              } else {
                dispatch(redeemRewardsAction(newCart, false));
              }

              return _context5.abrupt("return", totalDiscountAmount);

            case 17:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5);
    }));

    return function (_x7) {
      return _ref7.apply(this, arguments);
    };
  }();
}

var handleRedeemRewards = function handleRedeemRewards(type) {
  return /*#__PURE__*/function () {
    var _ref8 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(dispatch, getState) {
      return _regeneratorRuntime.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              return _context6.abrupt("return", dispatch(redeemRewards(getState(), type)));

            case 1:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6);
    }));

    return function (_x8, _x9) {
      return _ref8.apply(this, arguments);
    };
  }();
};

var applyRewards = function applyRewards(state, rewardsData) {
  var account = getSessionStorageKey('account');
  var loyalty = getSessionStorageKey('loyalty');
  return /*#__PURE__*/function () {
    var _ref9 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(dispatch) {
      var _account$aadResponse2, _loyalty$account, _account$aadResponse3, _account$aadResponse4, _account$aadResponse5, _account$aadResponse6, _account$aadResponse7, _account$aadResponse8;

      var url, token, loyaltyId, loyaltyEmail, data;
      return _regeneratorRuntime.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              url = UTIL.apiUtil.API.cart.postLoyaltyData;
              token = account === null || account === void 0 ? void 0 : (_account$aadResponse2 = account.aadResponse) === null || _account$aadResponse2 === void 0 ? void 0 : _account$aadResponse2.jwtIdToken; // storybook mock

              if (!(window.location.href.indexOf("localhost:9009") > -1)) {
                _context7.next = 5;
                break;
              }

              dispatch(receiveCart(newCart(state, setloyaltydataResponse.Data)));
              return _context7.abrupt("return", Promise.resolve({
                success: true
              }));

            case 5:
              loyaltyId = loyalty === null || loyalty === void 0 ? void 0 : (_loyalty$account = loyalty.account) === null || _loyalty$account === void 0 ? void 0 : _loyalty$account.ExternalCustomerId;
              loyaltyEmail = (account === null || account === void 0 ? void 0 : (_account$aadResponse3 = account.aadResponse) === null || _account$aadResponse3 === void 0 ? void 0 : (_account$aadResponse4 = _account$aadResponse3.account) === null || _account$aadResponse4 === void 0 ? void 0 : (_account$aadResponse5 = _account$aadResponse4.idToken) === null || _account$aadResponse5 === void 0 ? void 0 : _account$aadResponse5.email) || (account === null || account === void 0 ? void 0 : (_account$aadResponse6 = account.aadResponse) === null || _account$aadResponse6 === void 0 ? void 0 : (_account$aadResponse7 = _account$aadResponse6.account) === null || _account$aadResponse7 === void 0 ? void 0 : (_account$aadResponse8 = _account$aadResponse7.idToken) === null || _account$aadResponse8 === void 0 ? void 0 : _account$aadResponse8.signInName);

              if (loyaltyEmail) {
                _context7.next = 9;
                break;
              }

              return _context7.abrupt("return", Promise.resolve(false));

            case 9:
              data = {
                loyaltyId: loyaltyId,
                loyaltyEmail: loyaltyEmail
              };

              if (!rewardsData) {
                rewardsData = {
                  LoyaltyRewardIDs: null,
                  LoyaltyCouponCodes: null,
                  LoyaltyDiscount: null,
                  LoyaltyValidationText: null
                };
              }

              return _context7.abrupt("return", UTIL.apiUtil.fetchPost(url, _objectSpread(_objectSpread({}, data), rewardsData || {}), token).then(function (res) {
                if (res === null || res === void 0 ? void 0 : res.Success) {
                  dispatch(receiveCart(newCart(state, res.Data)));
                  var result = {
                    success: true
                  };
                  return result || false;
                } else {
                  return false;
                }
              }).catch(function (err) {
                console.error("Error on Loyalty Data Post request: ", err);
                dispatch(receiveError(UTIL.buildError(err)));
                return false;
              }));

            case 12:
            case "end":
              return _context7.stop();
          }
        }
      }, _callee7);
    }));

    return function (_x10) {
      return _ref9.apply(this, arguments);
    };
  }();
};

var handleApplyRewards = function handleApplyRewards(rewardsData) {
  return /*#__PURE__*/function () {
    var _ref10 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(dispatch, getState) {
      return _regeneratorRuntime.wrap(function _callee8$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              return _context8.abrupt("return", dispatch(applyRewards(getState(), rewardsData)));

            case 1:
            case "end":
              return _context8.stop();
          }
        }
      }, _callee8);
    }));

    return function (_x11, _x12) {
      return _ref10.apply(this, arguments);
    };
  }();
};

var getGiftCardBalance = function getGiftCardBalance(state, giftCardData) {
  return /*#__PURE__*/function () {
    var _ref11 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9(dispatch) {
      var _state$account23, _state$account23$aadR;

      var url, token, cart, giftCardScheme;
      return _regeneratorRuntime.wrap(function _callee9$(_context9) {
        while (1) {
          switch (_context9.prev = _context9.next) {
            case 0:
              url = UTIL.apiUtil.API.cart.getgiftcardbalance;
              token = (_state$account23 = state.account) === null || _state$account23 === void 0 ? void 0 : (_state$account23$aadR = _state$account23.aadResponse) === null || _state$account23$aadR === void 0 ? void 0 : _state$account23$aadR.jwtIdToken;
              cart = state.cart;
              giftCardScheme = cart === null || cart === void 0 ? void 0 : cart.giftCardScheme;

              if (giftCardScheme) {
                _context9.next = 6;
                break;
              }

              return _context9.abrupt("return", Promise.resolve(false));

            case 6:
              giftCardData = _objectSpread(_objectSpread({}, giftCardData), {}, {
                "billingSchemeId": giftCardScheme
              });
              console.log("Gift Card Data: ", giftCardData); // storybook mock

              if (!(window.location.href.indexOf("localhost:9009") > -1)) {
                _context9.next = 11;
                break;
              }

              dispatch(receiveCart(newCart(state, giftCardBalanceResponse)));
              return _context9.abrupt("return", Promise.resolve(giftCardBalanceResponse));

            case 11:
              return _context9.abrupt("return", UTIL.apiUtil.fetchPost(url, giftCardData, token).then(function (json) {
                if (json) {
                  dispatch(receiveCart(newCart(state, json)));
                  return json;
                } else {
                  return false;
                }
              }).catch(function (err) {
                console.error("Error on Get Gift Card Balance request: ", err);
                dispatch(receiveError(UTIL.buildError(err)));
                return false;
              }));

            case 12:
            case "end":
              return _context9.stop();
          }
        }
      }, _callee9);
    }));

    return function (_x13) {
      return _ref11.apply(this, arguments);
    };
  }();
};

var handleGetGiftCardBalance = function handleGetGiftCardBalance(giftCardData) {
  return /*#__PURE__*/function () {
    var _ref12 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10(dispatch, getState) {
      return _regeneratorRuntime.wrap(function _callee10$(_context10) {
        while (1) {
          switch (_context10.prev = _context10.next) {
            case 0:
              return _context10.abrupt("return", dispatch(getGiftCardBalance(getState(), giftCardData)));

            case 1:
            case "end":
              return _context10.stop();
          }
        }
      }, _callee10);
    }));

    return function (_x14, _x15) {
      return _ref12.apply(this, arguments);
    };
  }();
};

var removeTipAndEntitlements = function removeTipAndEntitlements(state, data) {
  return /*#__PURE__*/function () {
    var _ref13 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee11(dispatch) {
      var _state$account24, _state$account24$aadR, _options$cartAdjustme;

      var url, token, cart, options, _cart$savedPromos, _options$promos;

      return _regeneratorRuntime.wrap(function _callee11$(_context11) {
        while (1) {
          switch (_context11.prev = _context11.next) {
            case 0:
              url = UTIL.apiUtil.API.cart.removeTipAndEntitlements;
              token = (_state$account24 = state.account) === null || _state$account24 === void 0 ? void 0 : (_state$account24$aadR = _state$account24.aadResponse) === null || _state$account24$aadR === void 0 ? void 0 : _state$account24$aadR.jwtIdToken;
              cart = state.cart;
              options = {
                cartAdjustmentsAndEntitlements: (data === null || data === void 0 ? void 0 : data.length) ? data : [],
                promos: []
              };

              if (!data.length) {
                if (cart.price.GiftCardTotal > 0) {
                  options.cartAdjustmentsAndEntitlements.push(removeTipAndEntitlementsOptions.giftCard);
                }

                if (cart.price.OloTip > 0) {
                  options.cartAdjustmentsAndEntitlements.push(removeTipAndEntitlementsOptions.tip);
                }

                if (cart === null || cart === void 0 ? void 0 : (_cart$savedPromos = cart.savedPromos) === null || _cart$savedPromos === void 0 ? void 0 : _cart$savedPromos.length) {
                  options.cartAdjustmentsAndEntitlements.push(removeTipAndEntitlementsOptions.promo);
                  options.promos = (cart === null || cart === void 0 ? void 0 : cart.savedPromos) || [];
                }
              }

              console.info("Remove tip and entitlements options: ", options); // storybook mock

              if (!(window.location.href.indexOf("localhost:9009") > -1)) {
                _context11.next = 9;
                break;
              }

              if (options === null || options === void 0 ? void 0 : (_options$promos = options.promos) === null || _options$promos === void 0 ? void 0 : _options$promos.length) {
                options.promos.forEach(function (promo) {
                  dispatch(removePromoCode(promo));
                });
              }

              return _context11.abrupt("return", Promise.resolve(true));

            case 9:
              if (!(options === null || options === void 0 ? void 0 : (_options$cartAdjustme = options.cartAdjustmentsAndEntitlements) === null || _options$cartAdjustme === void 0 ? void 0 : _options$cartAdjustme.length)) {
                _context11.next = 13;
                break;
              }

              return _context11.abrupt("return", UTIL.apiUtil.fetchPost(url, options, token).then(function (json) {
                if (json) {
                  var _options$promos2;

                  dispatch(receiveCart(newCart(state, json)));

                  if (options === null || options === void 0 ? void 0 : (_options$promos2 = options.promos) === null || _options$promos2 === void 0 ? void 0 : _options$promos2.length) {
                    options.promos.forEach(function (promo) {
                      dispatch(removePromoCode(promo));
                    });
                  }

                  return true;
                } else {
                  return false;
                }
              }).catch(function (err) {
                console.error("Error on Reset Tip and Entitlements request: ", err);
                dispatch(receiveError(UTIL.buildError(err)));
                return false;
              }));

            case 13:
              return _context11.abrupt("return", Promise.resolve(true));

            case 14:
            case "end":
              return _context11.stop();
          }
        }
      }, _callee11);
    }));

    return function (_x16) {
      return _ref13.apply(this, arguments);
    };
  }();
};

var handleRemoveTipAndEntitlements = function handleRemoveTipAndEntitlements(data) {
  return /*#__PURE__*/function () {
    var _ref14 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee12(dispatch, getState) {
      return _regeneratorRuntime.wrap(function _callee12$(_context12) {
        while (1) {
          switch (_context12.prev = _context12.next) {
            case 0:
              return _context12.abrupt("return", dispatch(removeTipAndEntitlements(getState(), data)));

            case 1:
            case "end":
              return _context12.stop();
          }
        }
      }, _callee12);
    }));

    return function (_x17, _x18) {
      return _ref14.apply(this, arguments);
    };
  }();
};

export default {
  getCart: getCart,
  postItem: postItem,
  deleteLine: deleteLine,
  closeAddTo: closeAddTo,
  patchLine: patchLine,
  postDeliveryMode: postDeliveryMode,
  setTimeWanted: setTimeWanted,
  setDeliveryInfo: setDeliveryInfo,
  setShippingMode: setShippingMode,
  submitCart: submitCart,
  closeCheckout: closeCheckout,
  resetGoToCheckout: resetGoToCheckout,
  saveForEdit: saveForEdit,
  getDeliveryOptions: getDeliveryOptions,
  postTip: postTip,
  postPromoCode: postPromoCode,
  saveDeliveryMode: saveDeliveryMode,
  setCurbside: setCurbside,
  setMixCartCustomFields: setMixCartCustomFields,
  deletePromoCode: deletePromoCode,
  validateOrder: validateOrder,
  hideValidateCart: hideValidateCart,
  clearCart: clearCart,
  checkGiftCard: checkGiftCard,
  dumpCart: dumpCart,
  getGiftCardSchema: getGiftCardSchema,
  removeGiftCard: removeGiftCard,
  removeAllGiftCards: removeAllGiftCards,
  clearStates: clearStates,
  getShippingModes: getShippingModes,
  setRetail: setRetail,
  getSavedCreditCards: getSavedCreditCards,
  setPaypalOrder: setPaypalOrder,
  requestPaypalOrder: requestPaypalOrder,
  resetPaypalOrder: resetPaypalOrder,
  getExcludedTimes: getExcludedTimes,
  postNewsletter: postNewsletter,
  getTokenExToken: getTokenExToken,
  handlePostLoyaltyData: handlePostLoyaltyData,
  handleRedeemRewards: handleRedeemRewards,
  resetRewardsCartAction: resetRewardsCartAction,
  handleApplyRewards: handleApplyRewards,
  handleGetGiftCardBalance: handleGetGiftCardBalance,
  handleRemoveTipAndEntitlements: handleRemoveTipAndEntitlements,
  resetSaveForEdit: resetSaveForEdit
};